import Logger from 'js-logger';
/**
 * Available keys for Web app
 */
export enum LsKey {
  Media = 'media',
  VbbDefault = 'VbbDefault',
  VbbImages = 'VbbImages',
  CookiesAccepted = 'cookiesAccepted',
  Email = 'email',
  EnableLogging = 'enableLogging',
  Locale = 'locale',
  Name = 'name',
  ReceiveStreams = 'receiveStreams',
  SkipTrialNavigationForTest = 'skipTrialNavigationForTest',
  TosAccepted = 'tosAccepted',
  simulateNewVersion = 'simulateNewVersion',
  testUnsupported = 'testUnsupported'
}

/**
 * Set a guest app key value from local storage
 * @param key - one of lsKey string enum
 * @param value - new value to set
 */
export const lsSet = (key: LsKey, value: string): void => {
  Logger.info(`Setting ${key} to ${value}`);
  return window.localStorage.setItem(key, value);
};

/**
 * Get a guest app key value from local storage
 * @param key - one of lsKey string enum
 */
export const lsGet = (key: LsKey): string | null => {
  Logger.debug(`Getting ${key}`);
  return window.localStorage.getItem(key);
};

/**
 * Remove a guest app key from local storage
 * @param key - one of lsKey string enum
 */
export const lsRemove = (key: LsKey): void => {
  Logger.debug(`Removing ${key}`);
  return window.localStorage.removeItem(key);
};
